import type {ClientPlatform} from './transport';

export const browserPlatform: ClientPlatform = {
  kind: 'browser',
  get publicOrigin() {return window.location.origin;},
  fetch: (path, init) => fetch(path, init),
  webSocket(address) {
    const url = new URL(address, window.location.href);
    if (url.protocol !== 'wss:' || url.host !== window.location.host) throw new Error('The connection must use this website’s secure address.');
    return new WebSocket(url);
  },
  async openPage(url) {window.location.assign(url);},
  async openAccountPage(path) {window.location.assign(path);},
  async loginWithPassword() {throw new Error('Website password sign-in is handled by the account store.');},
  async registerWithPassword() {throw new Error('Website registration is handled by the account store.');},
  async pendingEmailCode() {throw new Error('Email-code sign-in is available in the desktop app.');},
  async startEmailCode() {throw new Error('Email-code sign-in is available in the desktop app.');},
  async finishEmailCode() {throw new Error('Email-code sign-in is available in the desktop app.');},
  async cancelEmailCode() {throw new Error('Email-code sign-in is available in the desktop app.');},
  async logout() { /* Browser session revocation is owned by the shared store. */ },
  accountChanged() { /* Browser private resources follow the shared store. */ },
  async saveFile(path, suggestedName) {
    const link = document.createElement('a');
    link.href = path;
    link.download = suggestedName ?? '';
    link.click();
  },
};
